// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

/* Valtech Custom Code - Start */
import { infoProps } from "@store/Themes/common/props/info";
/* Valtech Custom Code - End */

// Foundation --->
import { orderDetailsSubTitle } from "@store/Themes/common/props/orderDetails";
// <--- Foundation

export interface OrderDetailsNotesStyles {
    titleText?: TypographyProps;
    notesText?: TypographyProps;
    wrapper?: InjectableCss;
    // Foundation
    noNotesText?: TypographyProps;
}

export const notesStyles: OrderDetailsNotesStyles = {
    wrapper: orderDetailsSubTitle.wrapper,
    titleText: orderDetailsSubTitle.titleText,
    // Foundation --->
    noNotesText: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
        `,
    },
    // <--- Foundation
};

const styles = notesStyles;

const OrderDetailsNotes = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.notes) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Order Notes")}</Typography>
            {/* Foundation - Add Condition */}
            {order && order.notes ? (
                <Typography {...styles.notesText}>{order.notes}</Typography>
            ) : (
                <Typography {...styles.noNotesText}>{translate("No Order Notes Added")}</Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsNotes,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
